import React, { forwardRef } from 'react';
export const AlertIcon = (StyledAlertIcon) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAlertIcon tabIndex={-1} ref={ref} {...props}>
        {children}
      </StyledAlertIcon>);
});
